import { render, staticRenderFns } from "./notifications_list.vue?vue&type=template&id=6aa05283&scoped=true&"
import script from "./notifications_list.vue?vue&type=script&lang=js&"
export * from "./notifications_list.vue?vue&type=script&lang=js&"
import style0 from "./notifications_list.vue?vue&type=style&index=0&id=6aa05283&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa05283",
  null
  
)

export default component.exports